"use client";

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGeoOnrampOptions } from "../../../../anyspend/react/index.js";
import { cn } from "../../../../shared/utils/cn.js";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";
export var FiatPaymentMethod;
(function (FiatPaymentMethod) {
  FiatPaymentMethod["NONE"] = "none";
  FiatPaymentMethod["COINBASE_PAY"] = "coinbase_pay";
  FiatPaymentMethod["STRIPE"] = "stripe";
  FiatPaymentMethod["STRIPE_WEB2"] = "stripe_web2";
})(FiatPaymentMethod || (FiatPaymentMethod = {}));
// Shared display config for fiat payment methods
export const FIAT_PAYMENT_METHOD_DISPLAY = {
  [FiatPaymentMethod.COINBASE_PAY]: {
    icon: "C",
    label: "Coinbase Pay"
  },
  [FiatPaymentMethod.STRIPE]: {
    icon: "S",
    label: "Pay via Stripe"
  },
  [FiatPaymentMethod.STRIPE_WEB2]: {
    icon: "S",
    label: "Pay with Card"
  },
  [FiatPaymentMethod.NONE]: null
};
export function FiatPaymentMethodComponent(t0) {
  const $ = _c(24);
  const {
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    onBack,
    onSelectPaymentMethod,
    srcAmountOnRamp,
    classes
  } = t0;
  const {
    coinbaseAvailablePaymentMethods,
    stripeOnrampSupport,
    stripeWeb2Support,
    isLoading: isLoadingGeoOnramp
  } = useGeoOnrampOptions(srcAmountOnRamp);
  let t1;
  if ($[0] !== stripeWeb2Support) {
    t1 = paymentMethod => {
      switch (paymentMethod) {
        case FiatPaymentMethod.COINBASE_PAY:
          {
            return null;
          }
        case FiatPaymentMethod.STRIPE_WEB2:
          {
            if (stripeWeb2Support && "formattedFeeUsd" in stripeWeb2Support) {
              return stripeWeb2Support.formattedFeeUsd;
            }
            return null;
          }
        case FiatPaymentMethod.STRIPE:
          {
            return null;
          }
        default:
          {
            return null;
          }
      }
    };
    $[0] = stripeWeb2Support;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getFeeFromApi = t1;
  let t2;
  let t3;
  if ($[2] !== classes?.backButton || $[3] !== classes?.container || $[4] !== classes?.header || $[5] !== classes?.optionItem || $[6] !== classes?.optionItemActive || $[7] !== classes?.optionsList || $[8] !== coinbaseAvailablePaymentMethods.length || $[9] !== getFeeFromApi || $[10] !== isLoadingGeoOnramp || $[11] !== onBack || $[12] !== onSelectPaymentMethod || $[13] !== selectedPaymentMethod || $[14] !== setSelectedPaymentMethod || $[15] !== stripeOnrampSupport || $[16] !== stripeWeb2Support) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const availablePaymentMethods = [];
      if (coinbaseAvailablePaymentMethods.length > 0) {
        const coinbaseFee = getFeeFromApi(FiatPaymentMethod.COINBASE_PAY);
        availablePaymentMethods.push({
          id: FiatPaymentMethod.COINBASE_PAY,
          name: "Coinbase Pay",
          description: "Debit card, bank account or Coinbase account",
          badge: coinbaseFee ? `$${coinbaseFee} fee` : "Lowest Fee",
          badgeColor: "bg-green-100 text-green-800",
          available: true
        });
      }
      if (stripeOnrampSupport) {
        const stripeFee = getFeeFromApi(FiatPaymentMethod.STRIPE_WEB2);
        availablePaymentMethods.push({
          id: FiatPaymentMethod.STRIPE,
          name: "Pay via Stripe",
          description: "Redirects to Stripe checkout",
          badge: stripeFee ? `$${Number(stripeFee).toFixed(2)} fee` : undefined,
          badgeColor: "bg-gray-100 text-gray-800",
          available: true
        });
      }
      if (stripeWeb2Support && stripeWeb2Support.isSupport) {
        const stripeFee_0 = getFeeFromApi(FiatPaymentMethod.STRIPE_WEB2);
        availablePaymentMethods.push({
          id: FiatPaymentMethod.STRIPE_WEB2,
          name: "Pay with Card",
          description: "Fast checkout",
          badge: stripeFee_0 ? `$${Number(stripeFee_0).toFixed(2)} fee` : undefined,
          badgeColor: "bg-gray-100 text-gray-800",
          available: true
        });
      }
      if (isLoadingGeoOnramp) {
        const t4 = classes?.container || "fiat-payment-method mx-auto w-full max-w-[460px] p-5";
        const t5 = classes?.header || "flex items-center gap-4";
        const t6 = classes?.backButton || "text-as-quaternary hover:text-as-primary flex h-8 w-8 items-center justify-center rounded-lg transition-colors";
        let t7;
        if ($[19] !== onBack || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
          t7 = _jsx("div", {
            className: t4,
            children: _jsxs("div", {
              className: "flex flex-col gap-6",
              children: [_jsxs("div", {
                className: t5,
                children: [_jsx("button", {
                  onClick: onBack,
                  className: t6,
                  children: _jsx(ChevronLeft, {
                    className: "h-6 w-6"
                  })
                }), _jsx("div", {
                  className: "flex-1",
                  children: _jsx("h2", {
                    className: "text-as-primary text-lg font-semibold",
                    children: "Choose payment method"
                  })
                })]
              }), _jsxs("div", {
                className: "flex items-center justify-center py-8",
                children: [_jsx(Loader2, {
                  className: "h-6 w-6 animate-spin"
                }), _jsx("span", {
                  className: "text-as-secondary ml-2 text-sm",
                  children: "Loading payment methods..."
                })]
              })]
            })
          });
          $[19] = onBack;
          $[20] = t4;
          $[21] = t5;
          $[22] = t6;
          $[23] = t7;
        } else {
          t7 = $[23];
        }
        t3 = t7;
        break bb0;
      }
      t2 = _jsx("div", {
        className: classes?.container || "fiat-payment-method mx-auto w-full max-w-[460px] p-5",
        children: _jsxs("div", {
          className: "flex flex-col gap-6",
          children: [_jsxs("div", {
            className: classes?.header || "flex items-center gap-4",
            children: [_jsx("button", {
              onClick: onBack,
              className: classes?.backButton || "text-as-quaternary hover:text-as-primary flex h-8 w-8 items-center justify-center rounded-lg transition-colors",
              children: _jsx(ChevronLeft, {
                className: "h-6 w-6"
              })
            }), _jsx("div", {
              className: "flex-1",
              children: _jsx("h2", {
                className: "text-as-primary text-lg font-semibold",
                children: "Choose payment method"
              })
            })]
          }), _jsx("div", {
            className: classes?.optionsList || "flex flex-col gap-3",
            children: availablePaymentMethods.length === 0 ? _jsx("div", {
              className: "fiat-payment-method-no-methods bg-as-surface-secondary border-as-border-secondary rounded-2xl border p-6 text-center",
              children: _jsx("p", {
                className: "text-as-secondary text-sm",
                children: "No payment methods available in your region for the selected amount."
              })
            }) : availablePaymentMethods.map(method => _jsxs("button", {
              onClick: () => {
                setSelectedPaymentMethod(method.id);
                onSelectPaymentMethod(method.id);
              },
              className: selectedPaymentMethod === method.id && classes?.optionItemActive || classes?.optionItem || cn("fiat-payment-method-item bg-as-surface-secondary border-as-border-secondary flex w-full items-center gap-4 rounded-2xl border p-4 transition-all duration-200", selectedPaymentMethod === method.id ? "border-as-brand bg-as-brand/10" : "hover:border-as-brand/50 hover:bg-as-brand/5"),
              children: [_jsx("div", {
                className: "flex h-12 w-12 items-center justify-center rounded-full bg-blue-600 text-2xl text-white",
                children: method.id === FiatPaymentMethod.COINBASE_PAY ? "C" : method.id === FiatPaymentMethod.STRIPE || method.id === FiatPaymentMethod.STRIPE_WEB2 ? "S" : "?"
              }), _jsxs("div", {
                className: "flex flex-1 flex-col items-start text-left",
                children: [_jsxs("div", {
                  className: "flex items-center gap-2",
                  children: [_jsx("span", {
                    className: "text-as-primary text-base font-semibold",
                    children: method.name
                  }), method.badge && _jsx("span", {
                    className: cn("rounded-full px-2 py-1 text-xs font-medium", method.badgeColor),
                    children: method.badge
                  })]
                }), _jsx("span", {
                  className: "text-as-primary/60 text-sm",
                  children: method.description
                })]
              }), selectedPaymentMethod === method.id && _jsx(ChevronRight, {
                className: "text-as-brand h-5 w-5"
              })]
            }, method.id))
          })]
        })
      });
    }
    $[2] = classes?.backButton;
    $[3] = classes?.container;
    $[4] = classes?.header;
    $[5] = classes?.optionItem;
    $[6] = classes?.optionItemActive;
    $[7] = classes?.optionsList;
    $[8] = coinbaseAvailablePaymentMethods.length;
    $[9] = getFeeFromApi;
    $[10] = isLoadingGeoOnramp;
    $[11] = onBack;
    $[12] = onSelectPaymentMethod;
    $[13] = selectedPaymentMethod;
    $[14] = setSelectedPaymentMethod;
    $[15] = stripeOnrampSupport;
    $[16] = stripeWeb2Support;
    $[17] = t2;
    $[18] = t3;
  } else {
    t2 = $[17];
    t3 = $[18];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return t2;
}